import { render, staticRenderFns } from "./InitialFormStep.vue?vue&type=template&id=895ccf4a&scoped=true"
import script from "./InitialFormStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitialFormStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InitialFormStep.vue?vue&type=style&index=0&id=895ccf4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895ccf4a",
  null
  
)

export default component.exports